import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ project, onClose, onDeleteConfirm, customTitle }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleConfirm = async () => {
        setIsDeleting(true);
        setErrorMsg('');
        try {
            const success = await onDeleteConfirm(project);
            if (!success) {
                setErrorMsg('Failed to delete project. Please try again.');
                setIsDeleting(false);
            }
        } catch (err) {
            setErrorMsg('Network error while deleting project.');
            setIsDeleting(false);
        }
    };

    return (
        <div className="delete-modal-overlay" onClick={onClose}>
            <div className="delete-modal-box" onClick={(e) => e.stopPropagation()}>
                <h2 className="delete-modal-title">{customTitle || "Delete project?"}</h2>
                <div className="delete-modal-body">
                    This will delete <strong>{project.title}</strong>. 
                    This action cannot be undone.
                </div>
                {errorMsg && (
                    <div className="delete-modal-error">
                        {errorMsg}
                    </div>
                )}
                <div className="delete-modal-actions">
                    <button 
                        className="delete-modal-btn-cancel" 
                        onClick={onClose}
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button 
                        className="delete-modal-btn-delete" 
                        onClick={handleConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
